import { defineComponent as _defineComponent } from 'vue'
import {computed, ref} from "vue";
import FilterMint from "../filters/FilterMint.vue";
import {EFilterOperatorsChange, FilterOperatorsBitmap, ISignalFilters} from "@/shared";
import FiltersGeneric from "@/components/automation/filters/FiltersGeneric.vue";

// props
interface IProps {
	data?: any;
	filters?: ISignalFilters;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SignalTokenVolumeChange',
  props: {
    data: null,
    filters: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
	data?: any;
	filters?: ISignalFilters;
};



const _availableFilters = [
	{key: "change_pct_1", name: "Volume Change (1 Minute)", ops: new FilterOperatorsBitmap(EFilterOperatorsChange), operator: 2, type: "float64", value: null},
	{key: "change_pct_5", name: "Volume Change (5 Minutes)", ops: new FilterOperatorsBitmap(EFilterOperatorsChange), operator: 2, type: "float64", value: null},
	{key: "change_pct_30", name: "Volume Change (30 Minutes)", ops: new FilterOperatorsBitmap(EFilterOperatorsChange), operator: 2, type: "float64", value: null},
	{key: "change_pct_1h", name: "Volume Change (1 Hour)", ops: new FilterOperatorsBitmap(EFilterOperatorsChange), operator: 2, type: "float64", value: null},
	{key: "change_pct_6h", name: "Volume Change (6 Hours)", ops: new FilterOperatorsBitmap(EFilterOperatorsChange), operator: 2, type: "float64", value: null},
	{key: "change_pct_12h", name: "Volume Change (12 Hours)", ops: new FilterOperatorsBitmap(EFilterOperatorsChange), operator: 2, type: "float64", value: null},
	{key: "change_pct_24h", name: "Volume Change (24 Hours)", ops: new FilterOperatorsBitmap(EFilterOperatorsChange), operator: 2, type: "float64", value: null},
]
const isInvalid = computed<boolean>(
	() => {
		if (FilterGenericRef.value?.data.length === 0)
			return true

		for (let i = 0; i < FilterGenericRef.value?.data.length; i++) {
			if (!FilterGenericRef.value?.data[i]?.value || FilterGenericRef.value?.data[i]?.value === 0) return true
		}
		return false

	});

const getData = computed<any>(() => {
	return {
		mint: mint.value,
		filters: FilterGenericRef.value?.data,
	};
});

// methods

// data
const FilterGenericRef = ref<InstanceType<typeof FiltersGeneric> | null>(null);

const mint = ref<string>(props.data?.mint ?? "");

// expose
expose({isInvalid, data: getData});

return { __sfc: true,props, _availableFilters, isInvalid, getData, FilterGenericRef, mint, FilterMint, FiltersGeneric }
}

})